export const SERVER_DOMAIN = 'https://chattyenglishbot.ru';